import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import { some } from 'lodash'
import { client } from '../apiItemGraphql'
import { setUserSessionMutation } from '../apiItemGraphql/userSession'

const initialState = {
  tcins: [],
  status: 'idle',
  error: null,
}

export const updateTcinsAndNavigateToMaintain = createAsyncThunk(
  'tcins/updateAndNavigate',
  async (tcins, { rejectWithValue }) => {
    try {
      const response = await client.mutate({
        mutation: setUserSessionMutation(),
        fetchPolicy: 'no-cache',
        variables: {
          session: {
            tcins,
          },
        },
      })

      if (response && some(response.errors)) {
        throw new Error('Failed to update session tcins')
      }
      return tcins
    } catch (error) {
      return rejectWithValue(error.message)
    }
  },
)

const tcinsSlice = createSlice({
  name: 'tcins',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(updateTcinsAndNavigateToMaintain.pending, (state) => {
        state.status = 'loading'
      })
      .addCase(updateTcinsAndNavigateToMaintain.fulfilled, (state, action) => {
        state.status = 'succeeded'
        state.tcins = action.payload
      })
      .addCase(updateTcinsAndNavigateToMaintain.rejected, (state, action) => {
        state.status = 'failed'
        state.error = action.payload
      })
  },
})

export default tcinsSlice.reducer
